export const ENTITY_TYPES: {[key: string]: string} = {
    ContactPerson: 'Contact person',
    ContactCompany: 'Contact company',
}